import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import notificationImage from "../assets/images/notification.svg";
import mainLogo from "../assets/images/Main-Logo.png";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { fetchAllNotification } from "../redux/slices/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";

const AuthNavbar = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const notificationContainerRef = useRef(null);

  const { notifications, total_pages, total_records } = useSelector((state) => state.userStore);
  const { systemConfiguration } = useSelector((state) => state.commonStore);
  const { logOut } = useAuth();

  const language = localStorage.getItem("language");

  const [isActive, setIsActive] = useState(false);

  const [show, setShow] = useState(false);
  const [allMessages, setAllMessages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [fetchingMore, setFetchingMore] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleNotifications = () => {
    setShow(true);
    setLoading(true);
    dispatch(fetchAllNotification())
      .then((res) => {
        if (res?.payload?.status == 1) {
          setAllMessages((res?.payload?.data || []).filter(item => item.is_read == 0));
          setCurrentPage(1);
          setLoading(false);
        } else {
          setLoading(false);
          toast.warning(res?.payload?.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("ERROR", err);
        setLoading(false);
      });
  }

  const handleScroll = useCallback(() => {
    const container = notificationContainerRef.current;
    if (!container || loading || fetchingMore) return;

    const isAtBottom =
      container.scrollHeight - container.scrollTop <= container.clientHeight + 50; // 50px threshold

    if (isAtBottom && currentPage < total_pages) {
      setFetchingMore(true);
      const prevHeight = container.scrollHeight;
      const nextPage = currentPage + 1;

      dispatch(fetchAllNotification())
        .then((res) => {
          const newMessages = (res?.payload?.data || []).filter(item => item.is_read == 0);
          setAllMessages((prev) => [...prev, ...newMessages]);
          setCurrentPage(nextPage);
          setTimeout(() => {
            setFetchingMore(false);
          }, 100);
        })
        .catch(() => setFetchingMore(false));
    }
  }, [loading, fetchingMore, currentPage, total_pages, dispatch]);

  useEffect(() => {
    const container = notificationContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  return (
    <>
      {" "}
      <nav className="navbar navbar-expand-lg dashboard-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            {/* <span className="brand-text"> */}
            {/* <img src={mainLogo} alt="Offary" /> */}
            <img src={systemConfiguration?.logo} alt="Offary" />
            {/* Best Alert */}
            {/* </span> */}
          </Link>

          <div className="d-flex gap-2">
            <div className="btn-group">
              <button
                type="button"
                className={`btn btn-outline-primary dropdown-toggle ${isActive ? "show" : ""
                  }`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="dropdownMenuButton"
                onClick={() => setIsActive(!isActive)}
              >
                {language?.toUpperCase()} <i className="fa fa-chevron-down"></i>
              </button>
              <ul
                className={`dropdown-menu mt-5 ${isActive ? "show" : ""}`}
                aria-labelledby="dropdownMenuButton"
              >
                <li
                  className="dropdown-item btn"
                  onClick={() => {
                    localStorage.setItem("language", "en");
                    window.location.reload();
                    setIsActive(false);
                  }}
                >
                  EN
                </li>
                <li
                  className="dropdown-item btn"
                  onClick={() => {
                    localStorage.setItem("language", "ar");
                    window.location.reload();
                    setIsActive(false);
                  }}
                >
                  AR
                </li>
              </ul>
            </div>
            <div className="custom-btn main-btn"
              onClick={() => handleNotifications()}
            >
              <img src={notificationImage} alt="" width={"18px"} />
            </div>
            <button
              type="button"
              className="custom-btn main-btn"
              onClick={() => logOut()}
            >
              {t("Logout")}
            </button>
          </div>
        </div>
      </nav>
      <Modal show={show} onHide={handleClose} size="lg" dialogClassName="custom-notification-modal">

        <div className="notification-header">
          <h3 className="notification-title">{t("New for you")}</h3>
          {allMessages?.length != 0 && <a href="#" className="mark-read-btn">{t("Mark all read")}</a>}
        </div>

        <ModalBody className="p-0">
          <div className="notification-list" ref={notificationContainerRef}>
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <div className="notification-item p-3 d-flex gap-2 align-items-center" key={index}>
                  <Skeleton circle height={50} width={50} />
                  <div className="flex-grow-1 text-start">
                    <Skeleton width={`60%`} height={14} />
                    <Skeleton width={`80%`} height={12} />
                  </div>
                </div>
              ))
            ) : allMessages?.length == 0 ? (
              <div className="notification-item p-3 d-flex gap-2 align-items-center" >
               <div className="flex-grow-1">
                  {t("No notifications Found")}
                </div>
              </div>
            ) : (
              allMessages?.map((notification, index) => (
                <div key={index}>
                  <div className="notification-item">
                    <img src={notification?.offer_image} alt="Leo Stanton" className="notification-avatar" />
                    <div className="notification-content">
                      <div className="notification-user">{notification?.title}</div>
                      <p className="notification-text m-0">{notification?.description}</p>
                    </div>
                    <div className="notification-dot"></div>
                  </div>
                </div>
              ))
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AuthNavbar;
